import React from 'react';

export const DefaultBudgetCell = ({ value }) => {
  const content = value || '';
  return (
    <div className="overflow-ellipsis" title={content}>
      {content}
    </div>
  );
};
